import apiFetch from '../apiFetch'

export default function (token, file, code) {
  const formData = new FormData()
  formData.append(file.name, file)
  return apiFetch({ endPoint: `AutoDossierExcel?code=${code}`, method: 'POST', body: formData, token: token, fileBody: true })
}
